import { createFileRoute } from "@tanstack/react-router";
import { RootCompaniesPage } from "@/rootCompanies/RootCompaniesPage";
import { parseRootCompaniesSearch } from "@/rootCompanies/rootCompaniesSearch";

export const Route = createFileRoute(
  "/_authenticated/platform-management_/companies",
)({
  validateSearch: parseRootCompaniesSearch,
  component: RootCompaniesRoute,
});

function RootCompaniesRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RootCompaniesPage
      {...search}
      onQueryChange={(q) => {
        void navigate({
          replace: true,
          search: (previous) => ({
            ...previous,
            page: 1,
            q: q.trim() || undefined,
          }),
        });
      }}
      onTypeChange={(type) => {
        void navigate({
          search: (previous) => ({ ...previous, page: 1, type }),
        });
      }}
      onPageChange={(page, replace = false) => {
        void navigate({
          replace,
          search: (previous) => ({ ...previous, page: Math.max(1, page) }),
        });
      }}
    />
  );
}
